import { App } from "./App";
let React = require("react");
let ReactDOM = require("react-dom");

ReactDOM.render( <App/>, document.getElementById('app'))